/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  title: 'light',

  colors: {
    primary: '#222',
    secundary: '#D63AF9',
    aside:'#835afd',

    background: '#f5f5f5',
    text: '#333',
    textarea:'#f5f5f5',
    code: '#f5f5f5',
    img:'',
  },
}; 